import React from 'react';

import { IconProps } from '../Icon.types';

export const VkPointerIcon = (props: IconProps) => {
  return (
    <svg {...props} color="#FFF" viewBox="0 0 54 56" fontSize="inherit">
      <path
        d="M39.625 6.50003L2.875 22.0609L23.3526 31.7013L51.25 2.75L33.0491 53.375L25.1875 36.6875"
        fill={props.color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
